import React, { useEffect, useCallback, useState } from 'react';

import './AnalyticsDashboardPage.scss';

import Button from '../../Components/atoms/Button/Button';

import AnalyticsDashboard from '../../Components/molecules/AnalyticsDashboard/AnalyticsDashboard';
import AnalyticsDashboardRealTime from '../../Components/molecules/AnalyticsDashboardRealTime/AnalyticsDashboardRealTime';

import classNames from 'classnames';

const AnalyticsDashboardPage = () => {
  const [section, setSection] = useState(
    localStorage.getItem('analyticsDashboardTabSelection') !== null
      ? localStorage.getItem('analyticsDashboardTabSelection')
      : 'real_time'
  );

  const [subSection, setSubSection] = useState(
    section === 'networkOverview' ? 'newsrooms' : section === 'platformOverview' ? 'usetmx' : 'users'
  ); // empty push for rebuild

  const lockScroll = useCallback(() => {
    if (
      (window.location.pathname === '/dashboard' ||
        (window.location.pathname === '/analytics' &&
          (localStorage.getItem('analyticsDashboardTabSelection') === 'real_time' ||
            localStorage.getItem('analyticsDashboardTabSelection') === 'tracker')) ||
        window.location.pathname === '/accessdashboard') === false
    ) {
      let root = document.querySelector(':root');
      root.style.overflowY = 'auto';
    } else {
      let rootStyle = document.querySelector(':root');
      rootStyle.style.overflowY = 'hidden';
    }
  }, []);

  useEffect(() => {
    lockScroll();
  }, [lockScroll]);

  // const setTabSection = useCallback((type) => {
  //   setSection(type);
  //   localStorage.setItem('analyticsDashboardTabSelection', type);
  // }, []);

  return (
    <>
      <section
        className={classNames('tmx-analyticsDashboardPage', {
          'tmx-analyticsDashboardPage--lock': true,
          'tmx-analyticsDashboardPage--lockOverview':
            section === 'platformOverview' || section === 'networkOverview'
        })}>
        <section className="tmx-analyticsDashboardPage__tab">
          <div className="tmx-analyticsDashboardPage__actions">
            <Button
              iconSize="medium"
              className={classNames(
                'tmx-analyticsDashboardPage__link tmx-analyticsDashboardPage__hideOnSmall',
                {
                  'tmx-analyticsDashboardPage__link--active': section === 'platformOverview'
                }
              )}
              handleClick={() => {
                setSection('platformOverview');
                setSubSection('usetmx');
                localStorage.setItem('analyticsDashboardTabSelection', 'platformOverview');
                lockScroll();
              }}>
              Platform Overview
            </Button>

            <Button
              iconSize="medium"
              className={classNames(
                'tmx-analyticsDashboardPage__link tmx-analyticsDashboardPage__hideOnSmall',
                {
                  'tmx-analyticsDashboardPage__link--active': section === 'networkOverview'
                }
              )}
              handleClick={() => {
                setSection('networkOverview');
                setSubSection('newsrooms');
                localStorage.setItem('analyticsDashboardTabSelection', 'networkOverview');
                lockScroll();
              }}>
              Network Overview
            </Button>

            <Button
              iconSize="medium"
              className={classNames(
                'tmx-analyticsDashboardPage__link tmx-analyticsDashboardPage__hideOnSmall',
                {
                  'tmx-analyticsDashboardPage__link--active': section === 'real_time'
                }
              )}
              handleClick={() => {
                setSection('real_time');
                setSubSection('users');
                localStorage.setItem('analyticsDashboardTabSelection', 'real_time');
                lockScroll();
              }}>
              Real-time
            </Button>
          </div>
        </section>
        {(section === 'platformOverview' ||
          section === 'networkOverview' ||
          section === 'real_time') && (
          <section className="tmx-analyticsDashboardPage__tab tmx-analyticsDashboardPage__tab--subSection">
            <div className="tmx-analyticsDashboardPage__actions">
              {section === 'networkOverview' && (
                <>
                  <Button
                    iconSize="medium"
                    className={classNames(
                      'tmx-analyticsDashboardPage__link tmx-analyticsDashboardPage__hideOnSmall',
                      {
                        'tmx-analyticsDashboardPage__link--active': subSection === 'newsrooms'
                      }
                    )}
                    handleClick={() => {
                      setSubSection('newsrooms');
                      lockScroll();
                    }}>
                    Newsrooms
                  </Button>
                  <Button
                    iconSize="medium"
                    className={classNames(
                      'tmx-analyticsDashboardPage__link tmx-analyticsDashboardPage__hideOnSmall',
                      {
                        'tmx-analyticsDashboardPage__link--active': subSection === 'business'
                      }
                    )}
                    handleClick={() => {
                      setSubSection('business');
                      lockScroll();
                    }}>
                    Business
                  </Button>
                  <Button
                    iconSize="medium"
                    className={classNames(
                      'tmx-analyticsDashboardPage__link tmx-analyticsDashboardPage__hideOnSmall',
                      {
                        'tmx-analyticsDashboardPage__link--active': subSection === 'rankingList'
                      }
                    )}
                    handleClick={() => {
                      setSubSection('rankingList');
                      lockScroll();
                    }}>
                    Ranking Lists
                  </Button>
                </>
              )}

              {section === 'platformOverview' && (
                <>
                  <Button
                    iconSize="medium"
                    className={classNames(
                      'tmx-analyticsDashboardPage__link tmx-analyticsDashboardPage__hideOnSmall',
                      {
                        'tmx-analyticsDashboardPage__link--active': subSection === 'usetmx'
                      }
                    )}
                    handleClick={() => {
                      setSubSection('usetmx');
                      lockScroll();
                    }}>
                    Usetmx
                  </Button>
                  <Button
                    iconSize="medium"
                    className={classNames(
                      'tmx-analyticsDashboardPage__link tmx-analyticsDashboardPage__hideOnSmall',
                      {
                        'tmx-analyticsDashboardPage__link--active': subSection === 'tmxSearch'
                      }
                    )}
                    handleClick={() => {
                      setSubSection('tmxSearch');
                      lockScroll();
                    }}>
                    TMX search
                  </Button>
                </>
              )}
            </div>
          </section>
        )}
        {(section === 'platformOverview' || section === 'networkOverview') &&
          (subSection === 'newsrooms' ||
            subSection === 'business' ||
            subSection === 'rankingList'||
            subSection === 'usetmx'||
            subSection === 'tmxSearch') && (
            <AnalyticsDashboard
              // setSection={setTabSection}
              subSection={subSection}></AnalyticsDashboard>
          )}
        {section === 'real_time' && (
          <AnalyticsDashboardRealTime
          // setSection={setTabSection}
          // subSection={subSection}
          ></AnalyticsDashboardRealTime>
        )}
      </section>
    </>
  );
};

AnalyticsDashboardPage.propTypes = {};

export default AnalyticsDashboardPage;
